import { Eye } from "lucide-react";

interface TemplatePreviewPanelProps {
  language: "cs" | "sk";
  previewHtml: string;
}

export default function TemplatePreviewPanel({ language, previewHtml }: TemplatePreviewPanelProps) {
  return (
    <div className="card">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-semibold text-gray-900 dark:text-white">
          <Eye className="mr-2 inline h-5 w-5" />
          Preview {language === "sk" ? "(SK)" : "(EN)"}
        </h3>
      </div>

      {/* Preview iframe */}
      <div className="rounded-lg border border-gray-200 bg-white dark:border-gray-700">
        <iframe
          srcDoc={`
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="UTF-8">
                <style>
                  body { font-family: system-ui, sans-serif; padding: 20px; margin: 0; }
                  * { box-sizing: border-box; }
                </style>
              </head>
              <body>${previewHtml || '<p style="color: #999;">Preview will appear here...</p>'}</body>
            </html>
          `}
          className="h-[500px] w-full rounded-lg"
          title="Template Preview"
        />
      </div>
    </div>
  );
}
